export interface IShaInputProps {
  label?: string;
  error?: string;
  inputContainerStyle?: any;
  labelStyle?: any;
  inputStyle?: any;
  isPasswordField?: boolean;
  containerStyle?: any;
  rightIcon?: any;
  leftIcon?: any;
  shakeOnError?: boolean;
  onChange?: any;
  onChangeText?: any;
  disabled?: boolean;
  onBlur?: any;
  secureTextEntry?: boolean;
  placeholder?: string;
}
